import LocalidadeModel from "@/models/geolocalizacao/LocalidadeModel";
import { QuestionarioModel } from "@/models/cadastros/assistencia/QuestionarioModel";
import { TipoLimitacao } from './TipoLimitacao';
import ServicoSubClienteModel  from '@/models/cadastros/assistencia/ServicoSubClienteModel';

export class QuestionarioTransporteAssociadoModel implements QuestionarioModel {
  idServico?: number;
  nomeSolicitante: string;
  nomeContatoLocal: string;
  telefoneContatoLocal: string;
  quantidadePessoas: number;
  possuiLimitacao: boolean;
  limitacao?: TipoLimitacao;
  descricaoLimitacao?: string;
  observacao?: string;
  enderecoSelecionado: LocalidadeModel;
  destinoSelecionado: LocalidadeModel;
  servicoSubCliente?: ServicoSubClienteModel;
  constructor(
    nomeSolicitante: string,
    nomeContatoLocal: string,
    telefoneContatoLocal: string,
    quantidadePessoas: number,
    possuiLimitacao: boolean,
    enderecoSelecionado: LocalidadeModel,
    destinoSelecionado: LocalidadeModel,
    limitacao?: TipoLimitacao,
    descricaoLimitacao?: string,
    observacao?: string,
    servicoSubCliente?: ServicoSubClienteModel
  ) {
    this.nomeSolicitante = nomeSolicitante;
    this.nomeContatoLocal = nomeContatoLocal;
    this.telefoneContatoLocal = telefoneContatoLocal;
    this.quantidadePessoas = quantidadePessoas;
    this.possuiLimitacao = possuiLimitacao;
    this.enderecoSelecionado = enderecoSelecionado;
    this.destinoSelecionado = destinoSelecionado;
    this.limitacao = limitacao;
    this.descricaoLimitacao = descricaoLimitacao;
    this.observacao = observacao;
    this.servicoSubCliente = servicoSubCliente;
  }
}
